import React from "react";
import { Route } from "react-router-dom";

const Home = React.lazy(() => import("../containers/Home"));
const MainSearch = React.lazy(() => import("../containers/MainSearch"));
const CourtFeeInvoices = React.lazy(
  () => import("../containers/CourtFeeInvoices")
);

export default () => {
  return [
    // <Route  key="home" path={"/"} render={(props: any) => <Home />} />,
    <Route  key="home" path={"/"} element={<Home />} />,
    <Route
      
      key="court-fee-invoices"
      path={"/court-fee-invoices"}
      // render={(props: any) => <CourtFeeInvoices {...props} />}
      element={ <CourtFeeInvoices />}
    />,
    // <Route
    //   key="search"
    //   path={"/search"}
    //   render={(props: any) => <MainSearch {...props} />}
    // />,
    <Route
      
      key="search"
      path={"/search"}
     element={  <MainSearch   />}
    />,
  ];
};
